import React, {MouseEvent} from 'react';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import Icon from '../../../common/Icon';
import BaseProps from "../../../types/BaseProps";

import './FatButton.scss';

export interface ClickHandler {
  (event: MouseEvent<HTMLButtonElement>): void;
}

/**
 * @param {ClickHandler} clickHandler a callback function to be invoked when this button is clicked
 * @param {string} className css class to be appended to the classList
 * @param {Object} icon a font-awesome icon name (reference https://fontawesome.com/icons?d=gallery&m=free)
 * @param {string} title a string to be rendered as a title for this button
 * @param {string} descr a string to be rendered as a description for this button
 */
type FatButtonProps = {
  icon: IconProp,
  title: string,
  descr: string,
  clickHandler?: ClickHandler
};

/**
 * Generic, styled, button like component.
 */
class FatButton extends React.Component<FatButtonProps & BaseProps> {

  constructor(props: any) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event: MouseEvent<HTMLButtonElement>) {
    this.props.clickHandler && this.props.clickHandler(event);
  }

  render() {
    const classes = classNames('FatButton', this.props.className);
    return (
      <button className={classes}
              onClick={this.onClick}>
        <Icon icon={this.props.icon} size="2x"/>
        <div className="btn-text">
          <p className="operation-title mb-0">{this.props.title}</p>
          <p className="operation-descr mb-0 text-muted">{this.props.descr}</p>
        </div>
      </button>
    );
  }
}

export default FatButton;
